<template lang="pug">
  grid(
    :name='$t("Payments")',
    desc='Manage Invoices & Payments'
    search
    search-placeholder='Invoices'
    :views='false'
    :sort='{ DueDateWithin: "desc", DueDateWithinFormatted: "desc" }'
    :endpoint='api.$.invoice.list.$'
    :screen='api.$.invoice.list.sent'
    alias='PaymentInvoiceList_SentInvoices'
    legacy
    :tabs='tabs'
    :row-classes='rowClasses'
    fit-columns
    footer
    @selectedRows='rowSelected'
    ref='grid'
    xadditional-filters='additionalFilters'
    :filter='defaultFilter'
    can-remove-default-filter
  )
    span(slot='overview')
      data-skybox
    span(slot='additionalButtons')
      //- edit-invoice(disabled)
      //- export-invoice(disabled)
      cancel-invoice(
        :ids='selectedRows'
        :disabled='cancelInvoiceDisabled'
        v-tooltip='cancelInvoiceDisabledReason'
        @success='refresh'
      )
    
    span(slot='selectionButtons')
      edit-invoice-for-supplier(
        :rows='selectedRows',
        fromPage='sent'
      )
    span(slot='additionalLabel')
      .form-group.no-margin
        <i class="fas fa-exclamation"></i>
        span &nbsp;
        label Click column headers to apply filters
    //-span(slot='additionalLabel')
      .form-group.no-margin
        label Statuses
    //-span.statuses-bar(slot='additionalFilters' slot-scope='props')
      span(v-for="status in statuses")
        a.badge(
          :class="{ 'active': statusActive(status).active, 'partially-active': false && statusActive(status).partial, [status.toLowerCase()]: true }"
          @click="handleStatusFilter(status)"
        ) {{ status }}
        span &nbsp;
</template>

<script>

import DataSkybox from '@/components/_modules/Invoices/data-skybox'

import Grid from '@/components/Grid'
import model from './model.js'
import tabs from '@/components/_modules/Invoices/tabs'

import users from '@/core/legacy-auth/users'

// import EditInvoice from '@/components/_modules/Invoices/actions/edit'
// import ExportInvoice from '@/components/_modules/Invoices/actions/export'
import CancelInvoice from '@/components/_modules/Invoices/actions/cancel'
import EditInvoiceForSupplier from '@/components/_modules/Invoices/actions/edit-invoice'

import config, { metaStatuses, cannotCancelReasons } from '@/components/_modules/Invoices/statuses'
const { additionalFilters, filters, isActiveFilter } = config

const defaultFilter = []

const cancelTooltip = 'Please select an invoice.'

export default {
  components: {
    DataSkybox,
    Grid,
    // EditInvoice,
    // ExportInvoice,
    CancelInvoice,
    EditInvoiceForSupplier
  },
  data() {
    return {
      additionalFilters,
      defaultFilter: this.$route.query.filter
        ? filters(this.$route.query.filter.split(','))
        : filters(defaultFilter),
      statuses: metaStatuses,
      model,
      tabs: tabs.tabs,
      rowClasses: {
        'negative-amount': params => (params.data || {}).TotalAmount < 0
      },
      selectedRows: [],
      selectedAll: null,
      asyncCancelInvoiceDisabledReason: cancelTooltip
    }
  },
  watch: {
    '$route.query.filter' (value, oldValue) {
      if (value && value !== oldValue) {
        this.$refs.grid.gridOptions.api.setFilterModel(null)
        this.defaultFilter = filters(value.split(','), {}, this.$route.query.filter && this.$route.query.filter.split(','))
        this.$refs.grid.gridOptions.api.setFilterModel(this.defaultFilter)
      }
    }
  },
  computed: {
    cancelInvoiceDisabled() {
      return !!this.cancelInvoiceDisabledReason
    },
    cancelInvoiceDisabledReason() {
      if (this.selectedRows.length > 1) {
        return 'You can only cancel one invoice at a time.'
      }

      if (this.selectedRows.length === 0) {
        return cancelTooltip
      }

      // if (isCancelled(this.selectedRows)) {
      //   return 'The selected invoice is already cancelled.'
      // }
      return this.asyncCancelInvoiceDisabledReason
    },
    selectedId() {
      return this.selectedRows && this.selectedRows[0] && this.selectedRows[0].data &&
      this.selectedRows[0].data.PaymentInvoiceID
    }
  },
  methods: {
    rowSelected(event) {
      if (typeof event === 'boolean') {
        this.selectedAll = event
      } else {
        this.selectedRows = event
        this.fetchCancelReason()
      }
    },
    refresh() {
      this.$refs.grid.refreshGrid()
    },
    handleStatusFilter(status) {
      this.$router.push({
        query: {
          filter: undefined
        }
      })

      this.$refs.grid.gridOptions.api.setFilterModel(
        filters(
          [status],
          this.$route.query.filter
            ? {}
            : this.$refs.grid.gridOptions.api.getFilterModel()
        )
      )
    },
    statusActive(status) {
      if (!this.$refs.grid) return {}
      return isActiveFilter(
        status,
        this.$refs.grid.gridOptions.api.getFilterModel(),
        this.$route.query.filter && this.$route.query.filter.split(',')
      )
    },
    async fetchCancelReason() {
      if (!this.selectedRows.length || this.selectedRows.length > 1) {
        this.asyncCancelInvoiceDisabledReason = cancelTooltip
        return
      }

      const tooltip = await this.api.forms.post(this.api.$.invoice.list.canCancelInvoice,
        {
          id: this.selectedId
        })
      const reason = cannotCancelReasons[tooltip.data.SuccessMessage]
      this.asyncCancelInvoiceDisabledReason = reason || ''

      return reason
    },
    redirectToList() {
      if (users.type.BS) {
        this.$router.replace('/i/Programs/Invoice-received/?goto=PaymentInvoice%2FSentInvoiceList')
      }
    }
  },
  activated() {
    this.redirectToList()
  },
  created() {
    this.redirectToList()
  }

}

</script>

<style lang="scss" scoped>
@import "~@/assets/sass/_variables.scss";
@import "~@/components/_modules/Invoices/statuses.scss";

.grid >>> {
  .ag-row.negative-amount {
    @include theme {
      background-color: lighten(v(urgent-02), 45%);
    }
  }
}

.statuses-bar {
  line-height: 40px;
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Invoice-sent/index.vue